import { counters } from './counters';

// Listing page name
const FAVOURITE_AD = 'favouriteAd';
const COMPARE_AD = 'compareAd';

export const favouriteAd = {
    element: null,
    adId: null,
    pageName: null,
    selectedClassName: null,
    hideShowLinkElement: null,
    init(opts) {
        this.element = opts.element;
        this.adId = opts.adId;
        this.pageName = opts.pageName;
        this.selectedClassName = opts.selectedClassName;
        this.hideShowLinkElement = opts.hideShowLinkElement;
    },
    add() {
        let csrfToken = $('#app').data('csrf-favourite-ad');
        $.post(Routing.generate('ajax_favourite_ad_add'), `adId=${this.adId}&token=${csrfToken}`, function (data) {
            if (data.success === false) {
                commonUtils.showNotification(data.message);
                return false;
            }

            favouriteAd.hideShowLink(data.total_for_sale_favourite_ads);
            counters.incrementByType('favorite-mobile');
            $(favouriteAd.element).addClass(favouriteAd.selectedClassName);
            // Hide the "Hide from search" button when adding to favorites
            let $productCard = $(favouriteAd.element).closest('.product-card');
            $productCard.find('.hideAdFromSearchResult, .removeAdFromHidden').addClass('none');

            if (favouriteAd.pageName === COMPARE_AD) {
                commonUtils.showNotification(data.message);
            } else {
                favouriteAd.openCommentDialog(favouriteAd.adId);
            }

            $('#notify_favourite').prop('checked', data.notify_favourite_permission === 'N');

            return undefined;
        });
        commonUtils.dataLayer.genericDataLayerEvent('addedToFavoriteList');
    },
    addComment(obj, redirect) {
        let adId = $('#addToFavouritePopup #adId').val();
        $.post($(obj).attr('action'), $(obj).serialize(), function (data) {
            $.colorbox.close();
            if (data.success) {
                if (redirect === 'Y') {
                    location.href = Routing.generate('favourite_ad_list');
                } else if ($(`.favouriteAdComment_${adId}`).length) {
                    $(`.favouriteAdComment_${adId}`).html(data.comment);
                    $(`.favouriteAdCommentLink_${adId}`).html(data.link_text);
                }
            }
            if (data.message) {
                commonUtils.showNotification(data.message);
            }
        });
    },
    remove() {
        if (!confirm(Translations.favourite.remove_message)) {
            return false;
        }

        if (commonUtils.isNettiauto()) {
            commonUtils.dataLayer.genericDataLayerEvent('removeFromFavoriteList');
        }

        let csrfToken = $('#app').data('csrf-favourite-ad');
        $.ajax({
            url: Routing.generate('favourite_ad_delete'),
            data: `adId=${this.adId}&token=${csrfToken}`,
            type: 'DELETE',
            success(data) {
                if (data.success) {
                    favouriteAd.hideShowLink(data.total_for_sale_favourite_ads);
                    $(favouriteAd.element).removeClass(favouriteAd.selectedClassName);
                    commonUtils.showNotification(data.message);
                    // Show the "Hide from search" button when removing from favorites, but only if ad is not in compare
                    let $productCard = $(favouriteAd.element).closest('.product-card');
                    let isInCompare = $productCard.find('.compareAd').hasClass('product-card__add-to-compare_added');
                    if (!isInCompare) {
                        $productCard.find('.hideAdFromSearchResult, .removeAdFromHidden').removeClass('none');
                    }

                    if (favouriteAd.pageName === FAVOURITE_AD) {
                        $(favouriteAd.element).closest('div.product-card').slideUp('slow');
                        $('.totalRecords').html(data.total_for_sale_favourite_ads);
                        if (data.total_for_sale_favourite_ads === 0) {
                            window.location.reload();
                        }
                    }
                } else if (data.message) {
                    commonUtils.showNotification(data.message);
                }
            },
        });

        return true;
    },
    openCommentDialog(adId) {
        $.colorbox({
            inline: true,
            href: '#addToFavouritePopup',
            onOpen() {
                $('#addToFavouritePopup #adId').val(adId);
                $('#addToFavouritePopup #comment').val('');

                // favouriteAdComment element exist in favourite ad listing
                if ($(`.favouriteAdComment_${adId}`).length) {
                    $('#addToFavouritePopup #comment').val($(`.favouriteAdComment_${adId}`).html());
                }
            },
            onClose() {
                $('#addToFavouritePopup #adId, #addToFavouritePopup #comment').val('');
            },
        });
    },
    changeButtonText(ele) {
        let buttonText = Translations.favourite.to_favorite_list;
        if ($(ele).val()) {
            buttonText = Translations.favourite.save_and_show_list;
        }
        $('#addToFavouritePopup #saveFavouriteList').text(buttonText);
    },
    hideShowLink(totalAd) {
        if (favouriteAd.hideShowLinkElement) {
            $(favouriteAd.hideShowLinkElement).css('display', totalAd > 0 ? 'flex' : 'none');
        }
    },
    setFavouritePermission(name, value) {
        // set/unset favourite permission
        let csrfToken = $('#app').data('csrf-favourite-ad');
        $.post(
            Routing.generate('ajax_favourite_ad_permission'),
            `name=${name}&value=${value ? 'N' : 'Y'}&token=${csrfToken}`,
            function (data) {
                if (data.success) {
                    commonUtils.showNotification(data.message);
                }
            }
        );
    },
};

$(function () {
    let $body = $('body');
    // Listing pages: add,remove ad from favourite list
    $body.on('click', '.addToFavouriteList', function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }

        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('search_page_tag_favorite');
            return;
        }

        favouriteAd.init({
            pageName: $(this).closest('.product-card').data('pagename'),
            adId: $(this).data('adid'),
            element: $(this),
            selectedClassName: 'product-card__ad-to-fav_added',
            hideShowLinkElement: '.favouriteAdListLink',
        });

        if ($(this).hasClass('product-card__ad-to-fav_added')) {
            favouriteAd.remove();
        } else {
            favouriteAd.add();
        }
    });

    // Add/Remove ad from favourite list from compare modal
    $body.on('click', '.addToFavouriteFromCompare', function () {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('compare_tag_favorite');
            return;
        }

        favouriteAd.init({
            pageName: 'compareAd',
            adId: $(this).data('adid'),
        });

        let $compareModalFavouriteElement = $(this).closest('.compare-modal__ad-to-fav');
        let adId = $(this).data('adid');
        if ($compareModalFavouriteElement.hasClass('compare-modal__ad-to-fav_added')) {
            if (favouriteAd.remove()) {
                $compareModalFavouriteElement.removeClass('compare-modal__ad-to-fav_added');

                // Update listing page element
                let $listingFavButton = $(`.addToFavouriteList[data-adid="${adId}"]`);
                if ($listingFavButton.length) {
                    $listingFavButton.removeClass('product-card__ad-to-fav_added');
                    // Show the "Hide from search" button on listing page, but only if ad is not in compare
                    let $productCard = $listingFavButton.closest('.product-card');
                    let isInCompare = $productCard.find('.compareAd').hasClass('product-card__add-to-compare_added');
                    if (!isInCompare) {
                        $productCard.find('.hideAdFromSearchResult, .removeAdFromHidden').removeClass('none');
                    }
                }

                // Add,Remove,Change caption for vif page
                if ($('.addToFavouriteFromVif').length) {
                    $('.addToFavouriteFromVifSticky')
                        .html(Translations.add_to_favourite)
                        .removeClass('page-features__show-favorites_open');
                    $('.addTofavouriteFromVifImage').removeClass('item-fav-added');
                    $('.sub-header-mobile__show-favorites').removeClass('sub-header-mobile__show-favorites_open');
                }
            }
        } else {
            favouriteAd.add();
            $compareModalFavouriteElement.addClass('compare-modal__ad-to-fav_added');

            // Update listing page element
            let $listingFavButton = $(`.addToFavouriteList[data-adid="${adId}"]`);
            if ($listingFavButton.length) {
                $listingFavButton.addClass('product-card__ad-to-fav_added');
                // Hide the "Hide from search" button on listing page when adding to favorites
                let $productCard = $listingFavButton.closest('.product-card');
                $productCard.find('.hideAdFromSearchResult, .removeAdFromHidden').addClass('none');
            }

            // Add,Remove,Change caption for vif page
            if ($('.addToFavouriteFromVif').length) {
                $('.addToFavouriteFromVifSticky')
                    .html(Translations.remove_from_favourite_double_line)
                    .addClass('page-features__show-favorites_open');
                $('.addTofavouriteFromVifImage').addClass('item-fav-added');
                $('.sub-header-mobile__show-favorites').addClass('sub-header-mobile__show-favorites_open');
            }
        }
    });

    $('#favouritePopup #comment').keyup(function () {
        favouriteAd.changeButtonText(this);
    });

    $('#favouritePopup #notify_favourite').click(function () {
        favouriteAd.setFavouritePermission($(this).attr('name'), this.checked);
    });

    $('#favouritePopup #saveFavouriteList').click(function () {
        favouriteAd.addComment(this.form, 'Y');
    });

    $('#favouritePopup #ok').click(function () {
        favouriteAd.addComment(this.form, 'N');
    });
});
